var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-form-item',{attrs:{"prop":_vm.prop,"label":_vm.label,"label-width":_vm.options.labelWidth,"rules":_vm.rules}},[_c('el-time-picker',_vm._b({staticStyle:{"width":"100%"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},'el-time-picker',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }